"use strict";

class SuperManageReportsController {

    constructor($scope, $parse, SSHttpService, SSUtilService, SSAppService, SSAlertService, OTPService, SSUserService) {
        const self = this;

        self.$scope = $scope;
        self.$parse = $parse;

        self.SSHttpService = SSHttpService;
        self.SSUtilService = SSUtilService;
        self.SSAppService = SSAppService;
        self.SSAlertService = SSAlertService;
        self.OTPService = OTPService;
        self.SSUserService = SSUserService;

        self.data = SHOWSUITE.data;

        self.reportParams = null;
        self.reportParamsError = {
            name: '',
            code: '',
            permission: '',
            url: ''
        };
        self.searchReportText = '';

        if (self.SSUserService.isSuper()) {
            self.init();
        }
    }

    init() {
        const self = this;
        self.getAllReports();
    }

    getAllReports() {
        const self = this;

        self.reports = null;

        let url = 'sec/super/reports';

        loading(true);
        self.SSHttpService.getAPIRequest(url).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.reports = response.data.reports;
            self.reportsToDisplay = self.reports;
        });
    }

    createReportModal(report) {
        const self = this;

        self.reportParamsError = {};

        if (report) {
            self.reportParams = angular.copy(report);

            self.reportParams.allow_multiple_properties = self.reportParams.allow_multiple_properties === 1;
            self.reportParams.is_old_report = self.reportParams.is_old_report === 1;
            // self.reportParams.show_date_range = self.reportParams.show_date_range === 1;
            self.reportParams.show_date_from = self.reportParams.show_date_from === 1;
            self.reportParams.show_date_to = self.reportParams.show_date_to === 1;
            self.reportParams.show_property = self.reportParams.show_property === 1;
            // WEB-4823: law firm filter in the download modal (e.g. R111); also keeps the report out of
            // Manage Email Schedules, as its emails are set up in Settings → Email Notifications
            self.reportParams.show_law_firm = self.reportParams.show_law_firm === true || Number(self.reportParams.show_law_firm) === 1;
            self.reportParams.route = self.reportParams.route === 1;

            self.reportParams.show_status_type = null;
            if (self.reportParams.show_status === 1) {
                self.reportParams.show_status_type = 'default_status';
            } else if (self.reportParams.show_ura_status === 1) {
                self.reportParams.show_status_type = 'ura_status';
            } else if (self.reportParams.show_option_issued_status === 1) {
                self.reportParams.show_status_type = 'option_issued_status';
            }
            self.reportParams.show_status_check = !!self.reportParams.show_status_type;

        } else {
            self.reportParams = {
                name: '',
                code: '',
                description: '',
                url: '',
                permission: '',
                route: false,
                // show_date_range: false,
                show_date_from: false,
                show_date_to: false,
                show_law_firm: false,
                show_status_check: false,
                show_status_type: null,
            };
        }

        self.radioDisable = !!report;

        $('#createReportModal').modal('show');

        $('#createReportModal').on('hide.bs.modal', function (e) {
            self.reportParams = null;
        });
    }

    validateReport() {
        const self = this;

        let validate = true;
        self.reportParamsError = {};

        if (!self.reportParams.type) {
            self.reportParamsError.type = 'Type is required';
            validate = false;
        }

        if (!self.reportParams.name) {
            self.reportParamsError.name = 'Name is required';
            validate = false;
        }

        if (!self.reportParams.code) {
            self.reportParamsError.code = 'Code is required';
            validate = false;
        }

        if (!self.reportParams.url) {
            self.reportParamsError.url = 'URL is required';
            validate = false;
        }

        if (!self.reportParams.permission) {
            self.reportParamsError.permission = 'Permission is required';
            validate = false;
        }

        return validate;
    }

    saveReport() {
        const self = this;

        if (!self.validateReport())
            return;

        self.reportParams.show_date_from = self.reportParams.show_date_from ? 1 : 0;
        self.reportParams.show_date_to = self.reportParams.show_date_to ? 1 : 0;
        self.reportParams.show_law_firm = self.reportParams.show_law_firm ? 1 : 0;
        self.reportParams.show_status = self.reportParams.show_status_type == 'default_status' ? 1 : 0;
        self.reportParams.show_ura_status = self.reportParams.show_status_type == 'ura_status' ? 1 : 0;
        self.reportParams.show_option_issued_status = self.reportParams.show_status_type == 'option_issued_status' ? 1 : 0;

        self.reportParamsError = {};

        let handleResponse = function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            $('#createReportModal').modal('hide');
            self.getAllReports();
        };

        loading(true);
        let url = 'sec/super/reports';

        if (self.reportParams.id) {
            url += '/' + self.reportParams.id;
            self.SSHttpService.putAPIRequest(url, self.reportParams).then(handleResponse);
        } else {
            self.SSHttpService.postAPIRequest(url, self.reportParams).then(handleResponse);
        }

    }

    searchReport() {
        const self = this;
        if (self.searchReportText) {
            self.reportsToDisplay = self.reports.filter(function (report) {
                return report.name.toLowerCase().includes(self.searchReportText.toLowerCase());
            });
        } else {
            self.reportsToDisplay = self.reports;
        }
    }

    checkDisable() {
        const self = this;

        return !self.reportParams.type;
    }

}

SuperManageReportsController.$inject = ['$scope', '$parse', 'SSHttpService', 'SSUtilService', 'SSAppService', 'SSAlertService', 'OTPService', 'SSUserService'];
app.controller('SuperManageReportsController', SuperManageReportsController);

